import dxfIconUrl from '@/assets/icons/file/dxf.svg?url';
import pdfIconUrl from '@/assets/icons/file/pdf.svg?url';
import loadingIconUrl from '@/assets/icons/default/loading.svg?url';
import whiteLoadingIconUrl from '@/assets/icons/default/loading-white.svg?url';
import { memo } from 'react';
import { IconProps } from './types';

export const CustomIconDXF = memo((props: IconProps) => <img src={dxfIconUrl} alt="DXF" {...props} />);

export const CustomIconPDF = memo((props: IconProps) => <img src={pdfIconUrl} alt="PDF" {...props} />);

export const CustomIconLoading = memo((props: IconProps) => <img src={loadingIconUrl} alt="Loading" {...props} />);

export const CustomWhiteIconLoading = memo((props: IconProps) => (
  <img src={whiteLoadingIconUrl} alt="Loading" {...props} />
));
